import { useIntl } from "@components/Intl"
import IntlLink from "@components/Intl/IntlLink"
import imgix from "@config/imgix"
import { ChoicesArticleCombination } from "@generated"
import { FC } from "react"
import * as S from "./Variants.elements"
import { getRelatedCombinationUrl } from "@lib/get-related-combination-url"

type ProductVariantsProps = {
  items: ChoicesArticleCombination[]
  uid: string
  relatedCombinationId: string
}

export const ProductVariants: FC<ProductVariantsProps> = ({
  items,
  uid,
  relatedCombinationId,
}) => {
  const { messages } = useIntl()

  return (
    <S.Grid>
      {items.map((product) => {
        const as = getRelatedCombinationUrl(
          messages.navigation[uid].url,
          relatedCombinationId,
          product
        )

        return (
          <IntlLink
            key={product.combi_no}
            href={`${messages.navigation.collectionProductDetail.url}`}
            as={as}
          >
            <S.Item key={product.id}>
              <S.Image
                src={imgix({
                  key: product.images[0].path.replace(".png", ""),
                  type: "articleCombination",
                  args: {
                    w: 500,
                    h: 500,
                  },
                })}
                alt="variant"
              />
            </S.Item>
          </IntlLink>
        )
      })}
    </S.Grid>
  )
}
